import { render, staticRenderFns } from "./GettingStarted.vue?vue&type=template&id=7822763d&scoped=true&"
import script from "./GettingStarted.vue?vue&type=script&lang=js&"
export * from "./GettingStarted.vue?vue&type=script&lang=js&"
import style0 from "./GettingStarted.vue?vue&type=style&index=0&id=7822763d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7822763d",
  null
  
)

export default component.exports